import { formatAmount } from './money';

/**
 * 获取URL参数
 * @param {*} name
 * @param {*} url
 * @returns
 */
function getParam(name, url) {
  url = url || window.location.href;
  var r = new RegExp("(\\?|#|&)" + name + "=([^&#]*)(&|#|$)"),
    m = url.match(r);
  return !m ? "" : m[2]
}

/**
 * 数字金额格式化
 * @param {*} number - 要格式化的数字
 * @param {number} decimals - 小数位数，默认为2
 * @param {string} decimalSeparator - 小数点分隔符，默认为'.'
 * @param {string} thousandsSeparator - 千位分隔符，默认为','
 * @returns {string} 格式化后的金额字符串
 */
function formatMoney(number, decimals = 2, decimalSeparator = '.', thousandsSeparator = ',') {
  const formatted = formatAmount(number, decimals, thousandsSeparator, decimalSeparator);
  return formatted || '0';
}

/**
 * 简化版金额格式化（常用）
 * @param {*} number - 要格式化的数字
 * @param {number} decimals - 小数位数，默认为2
 * @returns {string} 格式化后的金额字符串
 */
function formatCurrency(number, decimals = 2) {
  return formatMoney(number, decimals, '.', ',');
}

/**
 * 校验手机号
 */
function validatePhone(phone) {
  // 08 开头：10-13位
  if (phone.startsWith("08")) {
    if (phone.length < 10 || phone.length > 13) return false
  }
  // 8 开头（不含0）：9-12位
  else if (phone.startsWith("8")) {
    if (phone.length < 9 || phone.length > 12) return false
  } else {
    return false
  }

  const regex = /\d{9,13}$/;
  return regex.test(phone);
}

export default {
  getParam,
  formatMoney,
  formatCurrency,
  validatePhone
}
